import request from '@/src/apis/axios';
import {
  DeleteHomeContentRequestBody,
  GetHomeContentByIdRequestParams,
  GetHomeContentsRequestParams,
  PostHomeContentRequestBody,
  PutHomeContentRequestBody,
  PutHomeContentsOrderRequestBody,
} from '@/src/apis/rest/homeContent.dtos';
import { HomeContentDto } from '@/src/models/HomeContentDto';
import { ListResponse, ObjectResponse } from '@/src/types/common';

const URL = {
  homeContents: '/admin/home-contents',
  homeContentCategories: '/home-contents/content-categories',
  homeContentInAppLinkCategories: '/home-contents/in-app-page-list',
};

// 홈 컨텐츠 리스트 조회
export const getHomeContentsAPI = async (
  queryParams: GetHomeContentsRequestParams,
) => {
  const { data } = await request<ListResponse<HomeContentDto>>({
    method: 'get',
    url: URL.homeContents,
    queryParams,
  });

  return data;
};
// 홈 컨텐츠 상세 조회
export const getHomeContentByIAPI = async (
  queryParams: GetHomeContentByIdRequestParams,
) => {
  const { id } = queryParams;

  const { data } = await request<ObjectResponse<HomeContentDto>>({
    method: 'get',
    url: `${URL.homeContents}/${id}`,
  });

  return data.row;
};

// 홈 컨텐츠 등록
export const postHomeContentAPI = async (
  requestBody: PostHomeContentRequestBody,
) => {
  const { data } = await request<ObjectResponse<HomeContentDto>>({
    method: 'post',
    url: URL.homeContents,
    requestBody,
  });

  return data?.row;
};

// 홈 컨텐츠 수정
export const putHomeContentAPI = async (
  requestBody: PutHomeContentRequestBody,
) => {
  const { id, ...body } = requestBody;

  const { data } = await request<ObjectResponse<HomeContentDto>>({
    method: 'put',
    url: `${URL.homeContents}/${id}`,
    requestBody: body,
  });

  return data?.row;
};

// 홈 컨텐츠 순서 수정
export const putHomeContentsOrderAPI = async (
  requestBody: PutHomeContentsOrderRequestBody,
) => {
  const { data } = await request<ObjectResponse<HomeContentDto>>({
    method: 'put',
    url: URL.homeContents,
    requestBody,
  });

  return data?.row;
};

// 홈 컨텐츠 수정
export const deleteHomeContentAPI = async (
  requestBody: DeleteHomeContentRequestBody,
) => {
  const { id } = requestBody;

  const { data } = await request<ObjectResponse<HomeContentDto>>({
    method: 'delete',
    url: `${URL.homeContents}/${id}`,
  });

  return data?.row;
};

// 홈 컨텐츠 카테고리 조회
export const getHomeContentCatetoryAPI = async () => {
  const { data } = await request<ListResponse<{ key: string; value: string }>>({
    method: 'get',
    url: URL.homeContentCategories,
  });

  return data;
};

// 홈 컨텐츠 in app 링크 카테고리 조회
export const getHomeContentInAppLinkCatetoryAPI = async () => {
  const { data } = await request<ListResponse<{ key: string; value: string }>>({
    method: 'get',
    url: URL.homeContentInAppLinkCategories,
  });

  return data;
};
